import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import ShareFormV2Modal from '../../../../common/components/ShareFormV2Modal/ShareFormV2Modal'
import { deleteFormAlias, fetchAlias, updateFormAlias } from '../../../actions/formsV2'
import { getTranslatedProperty } from '../../../../common/models/formsV2'
import {
  API_STATE_PROPS,
  APP_STATE_PROPS,
  FLAGS_STATE_PROPS,
  FORMSV2_STATE_PROPS,
  PLAN_STATE_PROPS,
  USER_STATE_PROPS
} from '../../../../common/constants/propTypes/coreWebPropTypes'
import { LANGUAGE_EN } from '../../../../common/constants/language'


export let ShareFormV2 = props => {

  const {
    api,
    app,
    dispatch,
    flags,
    form,
    formsV2,
    plan,
    renderTo,
    t: translate,
    user
  } = props
  const { language = LANGUAGE_EN } = app || {}
  const { hiddenFields, id: formId } = form || {}
  const { formAliases, isAliasLoading } = formsV2 || {}

  const formAlias = formAliases[formId]
  const formTitle = getTranslatedProperty(form, 'title', language)
  const isHiddenFieldsEnabled = flags?.configs?.formBuilderFeatureCompliant ?
    plan?.planFeatures?.newForms?.hiddenFields === true : true

  return (
    <ShareFormV2Modal
      apiError={api?.errors}
      flagConfig={{
        domain: flags?.configs?.domain,
        protocol: flags?.configs?.protocol || 'https'
      }}
      formAlias={formAlias}
      formId={formId}
      formTitle={formTitle}
      hiddenFields={hiddenFields}
      isAliasLoading={isAliasLoading}
      isHiddenFieldsEnabled={isHiddenFieldsEnabled}
      language={language}
      closeModal={() => dispatch({ type: 'OPEN_MODAL', data: null })}
      deleteAlias={formId => dispatch(deleteFormAlias(formId))}
      fetchAlias={formId => dispatch(fetchAlias(formId))}
      updateAlias={(formId, { alias, language }) => dispatch(updateFormAlias(formId, { alias, language }))}
      setApiError={error => dispatch({ type: 'SET_API_ERROR', data: error })}
      setToast={data => {
        dispatch({ type: 'SHOW_TOAST', data: {
          ...data,
          ...(data?.title ? { title: translate(data.title) } : {}),
          ...(data?.body ? { body: translate(data.body) } : {}),
        }})
      }}
      renderTo={renderTo}
      translate={translate}
      user={user}
    />
  )
}

ShareFormV2.defaultProps = {
  renderTo: null,
}

ShareFormV2.propTypes = {
  api: PropTypes.shape(API_STATE_PROPS).isRequired,
  app: PropTypes.shape(APP_STATE_PROPS).isRequired,
  dispatch: PropTypes.func.isRequired,
  flags: PropTypes.shape(FLAGS_STATE_PROPS).isRequired,
  form: PropTypes.object.isRequired,
  formsV2: PropTypes.shape(FORMSV2_STATE_PROPS).isRequired,
  plan: PropTypes.shape(PLAN_STATE_PROPS).isRequired,
  renderTo: PropTypes.instanceOf(Element),
  t: PropTypes.func.isRequired,
  user: PropTypes.shape(USER_STATE_PROPS).isRequired,
}

const select = (state) => ({
  api: state.api,
  app: state.app,
  dispatch: state.dispatch,
  flags: state.flags,
  formsV2: state.formsV2,
  plan: state.plan,
  user: state.user,
})

ShareFormV2 = connect(select)(ShareFormV2)

export default withTranslation([ 'modals', 'global' ])(ShareFormV2)
